module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 017.dcd52fe3.jpg";